import { Metrics } from '../metrics/metrics';
import { parseTypeName } from '../resources/resource';
export const createEmissionBuffer = ({
  onFlush,
  onFlushTypes
}) => {
  let pending = new Map();
  let flushScheduled = false;
  let readyAt = 0;
  const flush = () => {
    const batch = pending;
    pending = new Map();
    flushScheduled = false;
    if (readyAt > 0) {
      Metrics.timer('emissionBuffer.flushDelay').update(performance.now() - readyAt);
      readyAt = 0;
    }
    const typeNames = new Set();
    for (const [instanceKey, state] of batch) {
      onFlush(instanceKey, state);
      typeNames.add(parseTypeName(instanceKey));
    }
    onFlushTypes(typeNames);
  };
  return {
    schedule: (instanceKey, state) => {
      pending.set(instanceKey, state);
      if (!flushScheduled) {
        flushScheduled = true;
        queueMicrotask(flush);
      }
    },
    propagationFinished: () => {
      if (flushScheduled) {
        readyAt = performance.now();
      }
    }
  };
};